import React from 'react';
import {connect} from "react-redux";
import PropTypes from 'prop-types';

import * as AdminActions from "../../../../actions/admin";
import {CompressList, isDefined, nullToBlank} from "../../../../../../common/src/util/lib";
import UserRoles from "../../../../../../common/src/enums/UserRoles";

class ChampionshipListList extends React.Component {
    static propTypes = {
        selectedChampionships: PropTypes.array.isRequired,
        updateSelection: PropTypes.func.isRequired,
    };

    constructor(props) {
        super(props);
        this.state = Object.assign({
            initialized: false,
        });
    }

    componentDidMount() {
        this.props.dispatch(AdminActions.getChampionships());
    }

    fields = [];
    render() {
        const result = this.props.admin.isChampionshipsRead ? <table className="data-table row-clickable">
            <thead>
                <tr>
                    <th scope="row"></th>
                    <th>Kode</th>
                    <th>Navn</th>
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <th>Sektionsgrupper</th> : null}
                    {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <th>Sektioner</th> : null}
                    <th>Type</th>
                    <th colSpan={2}>Pointsystem</th>
                </tr>
            </thead>
            <tbody>
                {this.props.admin.championships.sort((c1, c2) => {
                    if (nullToBlank(c1.Nr) < nullToBlank(c2.Nr)) return -1;
                    if (nullToBlank(c1.Nr) > nullToBlank(c2.Nr)) return 1;
                    if (nullToBlank(c1.Titel) < nullToBlank(c2.Titel)) return -1;
                    if (nullToBlank(c1.Titel) > nullToBlank(c2.Titel)) return 1;
                    if (nullToBlank(c1.Sektionsgrupper) < nullToBlank(c2.Sektionsgrupper)) return -1;
                    if (nullToBlank(c1.Sektionsgrupper) > nullToBlank(c2.Sektionsgrupper)) return 1;
                    if (nullToBlank(c1.Sektioner) < nullToBlank(c2.Sektioner)) return -1;
                    if (nullToBlank(c1.Sektioner) > nullToBlank(c2.Sektioner)) return 1;
                    if (nullToBlank(c1.Type) < nullToBlank(c2.Type)) return -1;
                    if (nullToBlank(c1.Type) > nullToBlank(c2.Type)) return 1;
                    if (nullToBlank(c1.Pointsystem) < nullToBlank(c2.Pointsystem)) return -1;
                    if (nullToBlank(c1.Pointsystem) > nullToBlank(c2.Pointsystem)) return 1;
                    if (nullToBlank(c1.Pointsystem2) < nullToBlank(c2.Pointsystem2)) return -1;
                    if (nullToBlank(c1.Pointsystem2) > nullToBlank(c2.Pointsystem2)) return 1;
                    if (c1.RecNr < c2.RecNr) return -1;
                    if (c1.RecNr > c2.RecNr) return 1;
                    return 0;
                }).toArray().map(champ => {
                    const sections = CompressList(champ.Sektioner);
                    const groups = CompressList(champ.Sektionsgrupper);
                    return <tr key={champ.RecNr} id={'row-' + champ.RecNr} onClick={() => {
                        this.props.updateSelection([champ.RecNr], this.props.selectedRaces.indexOf(champ.RecNr) < 0)
                    }}>
                        <th scope="row"><input type="checkbox" checked={this.props.selectedRaces.indexOf(champ.RecNr) >= 0}/></th>
                        <td onClick={(e) => {
                            e.stopPropagation();
                            this.props.updateSelection(this.props.admin.championships.filter(otherChamp => otherChamp.Nr === champ.Nr).map(champ => champ.RecNr).toArray(), this.props.selectedRaces.indexOf(champ.RecNr) < 0)
                        }}><a href="javascript:void(0)">{champ.Nr}</a></td>
                        <td>{champ.Titel}</td>
                        {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>{groups.items.join(',')}</td> : null}
                        {this.props.auth.currentRole === UserRoles.MAIN_ADMIN.id ? <td>{sections.items.join(',')}</td> : null}
                        <td>{champ.Type}</td>
                        <td>{champ.Pointsystem}</td>
                        <td>{champ.Pointsystem2}</td>
                    </tr>
                })}
            </tbody>
        </table> : null;

        return result;
    }
}

const mapStateToProps = (state) => ({
    auth: {
        currentRole: state.auth.currentRole,
        currentEntity: state.auth.currentEntity,
    },
    admin: {
        championships: state.admin.championships,
        isChampionshipsRead: state.admin.isChampionshipsRead,
    },
});

export default connect(mapStateToProps, null, null, {withRef: true})(ChampionshipListList);


// WEBPACK FOOTER //
// ./src/client/src/components/pages/reporting/common/ChampionshipList.js